import { __decorate } from "tslib";
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { WebsiteThemeService } from "../../../../services/website-theme.service";
import { WebClientService } from "../../../../services/webclient-settings.service";
import { CreateStakeComponent } from "../create-stake/create-stake.component";
import { AuthenticationWalletModalComponent } from "../../authentication-wallet-modal/authentication-wallet-modal.component";
import { WelcomeToStakingComponent } from "../welcome-to-staking/welcome-to-staking.component";
import { ComponentService } from "../../../../services/component.service";
let StakingPotentialComponent = class StakingPotentialComponent {
    constructor(sanitizer, themeService, webSettingsService, compService) {
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.webSettingsService = webSettingsService;
        this.compService = compService;
        this.borderRadiusLarger = '';
        this.stakingPotential = 0;
        this.blogLink = '';
        this.goToStakingTab = new EventEmitter();
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        this.webSettingsService.getSettings().subscribe((data) => {
            this.blogLink = this.webSettingsService.getWebSetting('STAKING.BLOG_LINK');
        });
    }
    ngOnInit() {
        this.calculateStakingPotential();
    }
    calculateStakingPotential() {
        this.stakeCurrencies.forEach(currency => {
            const wallet = this.wallets.find(wallet => wallet.wallet.currency.verboseId === currency.verboseId);
            if (wallet) {
                const rewardRate = Number(currency.stakingReward) / 100;
                const amount = Number(wallet.wallet.spendableTotal);
                this.stakingPotential += amount * rewardRate * this.prices.usd_prices[currency.verboseId.toLowerCase()];
            }
        });
    }
    createNewStake() {
        this.compService.openModal(WelcomeToStakingComponent, {}, () => {
            this.compService.openModal(CreateStakeComponent, {
                stakeCurrencies: this.stakeCurrencies,
                selectedCurrency: this.stakeCurrencies[0],
                wallets: this.wallets
            }, () => {
                this.goToStakeTab();
                this.compService.openModal(AuthenticationWalletModalComponent, {
                    authenticated: true,
                    type: 'stake',
                    isSuccess: true
                });
            });
        });
    }
    goToStakeTab() {
        this.goToStakingTab.emit(true);
    }
};
StakingPotentialComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: WebClientService },
    { type: ComponentService }
];
__decorate([
    Input()
], StakingPotentialComponent.prototype, "stakeCurrencies", void 0);
__decorate([
    Input()
], StakingPotentialComponent.prototype, "wallets", void 0);
__decorate([
    Input()
], StakingPotentialComponent.prototype, "prices", void 0);
__decorate([
    Output()
], StakingPotentialComponent.prototype, "goToStakingTab", void 0);
StakingPotentialComponent = __decorate([
    Component({
        selector: 'ecd-staking-potential',
        template: __importDefault(require("./staking-potential.component.html")).default
    })
], StakingPotentialComponent);
export { StakingPotentialComponent };
